import React from 'react';
import { Tooltip, TooltipProps } from 'primereact/tooltip';
import classes from './Tooltip.module.scss';
import { Icon, IconPropsType } from '../../images/Icon/Icon';
import { IconsEnum } from '../../../constants/icons';
import classNames from 'classnames';
import { capitalize } from 'lodash';

export type TooltipViewProps = TooltipProps & {
  icon?: 'alert' | 'warning';
  iconsSize?: IconPropsType['size'];
  target: string;
  children: JSX.Element | string;
  pointer?: boolean;
  type: 'inlined' | 'regular';
  className?: string;
};

const excludedProps = ['variant', 'pointer', 'type'];

export const TooltipView = (props: TooltipViewProps): JSX.Element => {
  let args: TooltipProps = {};
  for (const [key, value] of Object.entries(props)) {
    if (!excludedProps.includes(key)) {
      args = {
        ...args,
        [key]: value
      };
    }
  }
  args = {
    ...args,
    showDelay: props.showDelay ?? 20,
    hideDelay: props.hideDelay ?? 0,
    className: `p-tooltip-dark${props.pointer ? '-pointer' : ''}`
  };
  if (args.content) {
    delete args.content;
  }

  let iconName = IconsEnum.help;
  let iconSize: IconPropsType['size'] = props.iconsSize || 'medium';

  switch (props.icon) {
    case 'alert':
    case 'warning':
      iconSize = props.iconsSize || 'large';
      iconName = IconsEnum.exclamation;
      break;
  }

  const tooltipClasses = classNames(classes.InlineTooltip, classes[`IconTooltip${capitalize(iconSize)}`], {
    [classes.InlineTooltipWarning]: props.icon === 'warning',
    [classes.InlineTooltipError]: props.icon === 'alert',
    [classes.InlineTooltipDisabled]: props.disabled,
    [props.className ?? '']: !!props.className
  });

  if (props.type === 'inlined') {
    return (
      <>
        <Tooltip {...args}>{props.children}</Tooltip>
        <span id={props.target.replace('#', '')} className={tooltipClasses}>
          <Icon name={iconName} size={iconSize} />
        </span>
      </>
    );
  }
  return <Tooltip {...args}>{props.children}</Tooltip>;
};
